import React from 'react'
import styled from 'styled-components'
const SOURCE_MAP = {
  atl: 'Atlantic',
  club: 'Crossword Club',
  db: 'The Daily Beast',
  pop: 'Daily Pop',
  std: 'Der Standard',
  tgam: 'The Globe And Mail cryptic',
  grdc: 'Guardian Cryptic',
  grde: 'Guardian Everyman',
  grdp: 'Guardian Prize',
  grdq: 'Guardian Quick',
  grdu: 'Guardian Quiptic',
  grds: 'Guardian Speedy',
  grdw: 'Guardian Weekend',
  lat: 'Los Angeles Times',
  mck: 'The McKinsey Crossword',
  nyt: 'New York Times',
  nytm: 'New York Times Mini',
  nytv: 'New York Times Variety',
  tny: 'The New Yorker',
  nd: 'Newsday',
  pzm: 'Puzzmo',
  sdp: 'Simply Daily Puzzles',
  sdpc: 'Simply Daily Puzzles Cryptic',
  sdpq: 'Simply Daily Puzzles Quick',
  uni: 'Universal',
  usa: 'USA Today',
  vox: 'Vox',
  wp: 'Washington Post',
}

const Tr = styled.tr`
  height: 32px;
  text-align: left;
  cursor: pointer;

  &:nth-child(even) {
    background-color: #5abd7f;
  }

  &:hover {
    background-color: #abffca;
  }
`
const Th = styled.th`
  text-align: left;
`

const Td = styled.td`
  padding: 0 8px;
`

const PuzzleTable = ({ files, onPreview, actionsDisabled, ...props }) => {
  return (
    <table {...props}>
      <thead>
        <tr>
          <Th>Title</Th>
          <Th style={{ textAlign: 'center' }}>Size</Th>
          <Th style={{ textAlign: 'center' }}>Source</Th>
          <Th style={{ textAlign: 'center' }}>Date Uploaded</Th>
        </tr>
        {files.map(f => {
          let size = '-'
          if (f.width && f.height) {
            size = `${f.width}x${f.height}`
          }
          return (
            <Tr
              key={f.filename}
              onClick={() => {
                if (!actionsDisabled) {
                  onPreview(f)
                }
              }}>
              <Td>{f.title}</Td>
              <Td style={{ textAlign: 'center' }}>{size}</Td>
              <Td style={{ textAlign: 'center' }}>{SOURCE_MAP[f.source] || f.source}</Td>
              <Td style={{ textAlign: 'center' }}>{new Date(f.created_at).toISOString().split('T')[0]}</Td>
            </Tr>
          )
        })}
      </thead>

    </table>
  )

}

export default PuzzleTable
